import React from 'react';
import './CustomCheckbox.css';

const CustomCheckbox = ({ checked, onChange }) => {
    return (
        <div className="mainDiv_r9a2g">
            <label className="customCheckbox_j3l0s">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                />
                <span className="checkmark_w1z8p"></span>
            </label>
        </div>
    );
};

export default CustomCheckbox;
